const API_BASE_URL_STORAGE_KEY = "prime_api_base_url";
const DEFAULT_API_BASE_URL = "https://sibagen.primeinsurancegambia.com";

function normalizeBaseUrl(url) {
  return (url || "").trim().replace(/\/$/, "");
}

export function getApiBaseUrl() {
  const runtimeUrl =
    typeof window !== "undefined" ? window.__PRIME_API_BASE_URL__ : "";
  const storedUrl =
    typeof window !== "undefined"
      ? window.localStorage.getItem(API_BASE_URL_STORAGE_KEY)
      : "";
  const envUrl = process.env.REACT_APP_API_BASE_URL || DEFAULT_API_BASE_URL;

  return normalizeBaseUrl(runtimeUrl || storedUrl || envUrl);
}

export function setApiBaseUrl(url) {
  if (typeof window === "undefined") {
    return;
  }

  const normalized = normalizeBaseUrl(url);
  window.__PRIME_API_BASE_URL__ = normalized;

  if (normalized) {
    window.localStorage.setItem(API_BASE_URL_STORAGE_KEY, normalized);
  } else {
    window.localStorage.removeItem(API_BASE_URL_STORAGE_KEY);
  }
}

export function serializeForm(formElement) {
  const payload = {};
  const fields = formElement.querySelectorAll("input, textarea, select");

  fields.forEach((field, index) => {
    if (
      field.type === "submit" ||
      field.type === "button" ||
      field.type === "reset"
    ) {
      return;
    }

    const key =
      field.name || field.id || field.placeholder || `field_${index + 1}`;

    if (field.type === "checkbox") {
      payload[key] = field.checked;
      return;
    }

    payload[key] = field.value;
  });

  return payload;
}

export async function submitFormPayload(formType, payload) {
  const apiBaseUrl = getApiBaseUrl();

  if (!apiBaseUrl) {
    return {
      ok: false,
      skipped: true,
      message: "",
    };
  }

  const endpoint = formType.startsWith("/") ? formType : `/${formType}`;
  const response = await fetch(`${apiBaseUrl}${endpoint}`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(payload),
  });

  if (!response.ok) {
    throw new Error(`Submission failed with status ${response.status}`);
  }

  const responseJson = await response.json();

  if (responseJson?.state === false) {
    throw new Error(responseJson?.message || "Submission failed.");
  }

  return {
    ok: Boolean(responseJson?.state ?? true),
    skipped: false,
    message: responseJson?.message || "Submitted successfully.",
    data: responseJson?.data,
    raw: responseJson,
  };
}
